










































































































































import { computed, defineComponent, watch } from "@vue/composition-api";

import Tooltip from "@/components/Tooltip.vue";
import RationaleSelect from "@/components/lien/RationaleSelect.vue";
import RelatedSelect from "@/components/lien/RelatedSelect.vue";
import EntryForm from "@/components/lien/EntryForm.vue";
import EntryCode from "@/components/lien/EntryCode.vue";

interface Props {
  entry: any;
}

export default defineComponent<Props>({
  name: "TableEntry",
  components: {
    EntryCode,
    EntryForm,
    RelatedSelect,
    RationaleSelect,
    Tooltip
  },
  props: {
    entry: { type: Object },
    targets: { type: Array },
    collapse: { type: Boolean },
    readonly: { type: Boolean, default: () => false }
  },
  setup(props, context) {
    const k = ([related, rationale], expected: number) =>
      related === false && rationale === expected;

    watch(
      () => props.entry.related,
      (next, old) => {
        if (next === true && old === false) {
          props.entry.rationale = [];
        }
      }
    );

    watch(
      () => props.entry.rationale,
      (next, old) => {
        if (
          (props.entry.dxCodes.some(code => code.bold) &&
            (!next.includes(1) && old.includes(1))) ||
          (next.includes(1) && !old.includes(1))
        )
          props.entry.dxCodes
            .filter(code => code.bold)
            .forEach(code =>
              context.emit("code-marked", {
                code: code.code,
                value: !next.includes(1) ? ["REMOVE", 1] : ["ADD", 1]
              })
            );
        if (
          (!next.includes(2) && old.includes(2)) ||
          (next.includes(2) && !old.includes(2))
        )
          context.emit("provider-marked", {
            provider: props.entry.providerName,
            value: !next.includes(2) ? ["REMOVE", 2] : ["ADD", 2]
          });
      }
    );

    const span = computed(() =>
      Math.max(props.entry.dxCodes.length, props.entry.pxCodes.length)
    );

    return { span };
  }
});
